import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { toast } from 'sonner';
import { errorMessage, HttpError } from '@/lib/api';

/** Erros de validação do servidor vão para os campos; os demais viram toast. */
export function handleFormError<T extends FieldValues>(e: unknown, form?: UseFormReturn<T>) {
  if (form && e instanceof HttpError && e.code === 'validation_error') {
    const fields = e.fieldErrors();
    const entries = Object.entries(fields);
    if (entries.length) {
      for (const [path, message] of entries) form.setError(path as Path<T>, { message });
      return;
    }
  }
  toast.error(errorMessage(e));
}
